/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'well-list-filter',
  templateUrl: './list-filter.component.html',
  styleUrls: ['./list-filter.component.scss']
})
export class ListFilterComponent implements OnInit {

  @Input() readonly size: 'big' | 'medium' | 'small' = 'medium';

  displayFilterPopup = false;

  constructor() { }

  ngOnInit() {
  }

  onToggleListFilters() {
    this.displayFilterPopup = !this.displayFilterPopup;
  }

  hide() {
    this.displayFilterPopup = false;
  }
}
